import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";

export const FeatureFlagGuard: FC<{
  render: () => React.ReactElement;
  flagKey: string;
}> = ({ render, flagKey }) => {
  const [flag] = useFeatureFlag(flagKey);

  if (flag) {
    return render();
  }

  return null;
};
